/**
 * Normalize geofips for deduping ghg_inventory_precalculated rows.
 * Leading-zero string variants (e.g. "0644000" vs "644000") map to the same key so stacked sums
 * do not double-count the same place.
 */

export function canonicalInventoryGeofipsKey(raw: unknown): string {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (/^-?\d+$/.test(s)) {
    const neg = s.startsWith('-');
    const body = neg ? s.slice(1) : s;
    const stripped = body.replace(/^0+/, '') || '0';
    return neg ? `-${stripped}` : stripped;
  }
  const n = Number(raw);
  if (Number.isFinite(n)) {
    const t = String(Math.trunc(n));
    const stripped = t.replace(/^0+/, '') || '0';
    return stripped;
  }
  return s;
}

export function inventoryGeofipsNumeric(raw: unknown): number | null {
  const k = canonicalInventoryGeofipsKey(raw);
  if (k === '' || k === '-') return null;
  const n = parseInt(k, 10);
  return Number.isFinite(n) ? n : null;
}

/** Prefer latest calculation_date; tie-break on higher total_emissions. */
export function preferNewerPrecalcRow<
  T extends { calculation_date?: string | null; total_emissions?: unknown }
>(a: T, b: T): T {
  const ta = Date.parse(String(a.calculation_date ?? ''));
  const tb = Date.parse(String(b.calculation_date ?? ''));
  const fa = Number.isFinite(ta) ? ta : -Infinity;
  const fb = Number.isFinite(tb) ? tb : -Infinity;
  if (fb !== fa) return fb > fa ? b : a;
  const va = Number(a.total_emissions);
  const vb = Number(b.total_emissions);
  const na = Number.isFinite(va) ? va : -Infinity;
  const nb = Number.isFinite(vb) ? vb : -Infinity;
  return nb >= na ? b : a;
}
